import React, { useState } from 'react';
import { ConfigProvider } from 'antd';
import uk_UA from 'antd/es/locale/uk_UA';
import 'moment/locale/uk';
import { CalendarOutlined, NotificationOutlined } from '@ant-design/icons';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import EventForm from './components/EventForm';
import AdvertisingForm from './components/AdvertisingForm';
import './PublicRequests.css';

const TABS = [
  {
    key: 'event',
    icon: <CalendarOutlined />,
    label: 'Бланк для заходу',
    description: 'Організація заходів, монтаж декорацій, торгівля',
  },
  {
    key: 'advertising',
    icon: <NotificationOutlined />,
    label: 'Рекламна конструкція',
    description: 'Розміщення реклами, банерів, експозицій',
  },
];

const PublicRequests = () => {
  const [activeTab, setActiveTab] = useState('event');

  return (
    <ConfigProvider locale={uk_UA}>
      {process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY ? (
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY}
          language="uk"
          useEnterprise
        >
          <div className="public-requests-page">
            {/* Хедер */}
            <div className="public-requests-header">
              <div className="public-requests-header-left">
                <img src="/images/logo.svg" alt="Республіка" />
                <div className="public-requests-header-divider" />
                <span className="public-requests-header-title">Портал для звернень</span>
              </div>
            </div>

            <div className="public-requests-body">
              {/* Кастомний switcher */}
              <div className="form-type-switcher">
                {TABS.map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    className={`form-type-btn ${activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    <span className="form-type-btn__icon">{tab.icon}</span>
                    <span className="form-type-btn__content">
                      <span className="form-type-btn__label">{tab.label}</span>
                      <span className="form-type-btn__desc">{tab.description}</span>
                    </span>
                  </button>
                ))}
              </div>

              <div className="public-requests-card">
                {activeTab === 'event' ? <EventForm /> : <AdvertisingForm />}
              </div>
            </div>
          </div>
        </GoogleReCaptchaProvider>
      ) : (
        <div style={{ padding: '50px', textAlign: 'center', color: 'red' }}>
          <h2>Помилка конфігурації</h2>
          <p>Ключ reCAPTCHA (REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY) не знайдено в оточенні.</p>
        </div>
      )}
    </ConfigProvider>
  );
};

export default PublicRequests;
